export const environment = {
  base_url: 'https://uat-api.xploraluxe.com/vendor/api/v1/',
  image_url: 'https://uat-api.xploraluxe.com/common/api/v1/upload/uploadDoc',
  operational_url: 'https://uat-api.xploraluxe.com/operational/api/v1/',
  rememberMeKey: 'XP_RM_K_M_U',
  googleKey: 'AIzaSyDIZwbQqi5J9a7DAHuTGs8_zbKK6by891s',
  storageKey: 'XP_ST_K_M_U',
  firebaseConfig: {
    apiKey: 'AIzaSyDh0KHjv2UtKo7J0njr5-O5E6hmhUJgXHk',
    authDomain: 'xplora-luxe.firebaseapp.com',
    projectId: 'xplora-luxe',
    storageBucket: 'xplora-luxe.firebasestorage.app',
    messagingSenderId: '768184676302',
    appId: '1:768184676302:web:80f1bbf0f164bcc539059f',
    measurementId: 'G-9ZHR95PGGC',
    vapidKey: 'BPd8igfMKQ7A5D82bBCi1_xFrv3Rf5ZmcCMatUPbO7tWE-Mlhh9CyzgVwnK6E_eWy2lo3f89nzfmDfpG1QdF82s'
  },
  path: '/firebase-messaging-sw.js',
  scope: '/'
};
  